import { NgModule } from '@angular/core';
import { ComponentsModule } from 'components/components.module';
import { AdminImpersonatedUserPage } from './admin-impersonated-user';
import { PagesModule } from 'pages/pages.module';

@NgModule({
    declarations: [AdminImpersonatedUserPage],
    imports: [PagesModule, ComponentsModule]
})
export class AdminImpersonatedUserPageModule { }
